import React from 'react';

export const ClockIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g strokeWidth="0.529">
                <circle
                    cx="2.91"
                    cy="2.91"
                    r="2.381"
                    fill="none"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                ></circle>
                <ellipse
                    cx="2.91"
                    cy="2.91"
                    fill="#fff"
                    rx="0.397"
                    ry="0.397"
                ></ellipse>
                <rect
                    width="0.397"
                    height="1.852"
                    x="2.712"
                    y="1.058"
                    fill="#fff"
                    ry="0.198"
                ></rect>
                <rect
                    width="0.397"
                    height="1.852"
                    x="0.854"
                    y="-5.53"
                    fill="#fff"
                    ry="0.198"
                    transform="rotate(120)"
                ></rect>
            </g>
        </svg>
    );
};
